import { AdminStatusHistoryModel } from "./adminStatusHistory.model";
import { TableColumn } from "./data-grid.model";
import { OrderItemAttributes } from "./orderItem.model";
import { PaymentMethod, RefundStatus } from "./payment.model";
import { PaymentDetailData, PhonePeResponse, PhonePeResponseV2 } from "./phonepe.model";
import { ProductAttributes, SingleBlockInfo } from "./product.model";
import { BaseRefund } from "./refund.model";
import { BaseReview } from "./review.model";
import { StructureAttributes } from "./structure.model";
import { AddressDetailsAttributes } from "./user.model";

export enum OrderStatus {
    Failed = "Failed",
    Pending = "Pending",
    Ordered = "Ordered",
    Packed = "Packed",
    Cancelled = "Cancelled",
    Dispatched = "Dispatched",
    Delivered = "Delivered",
    ReturnInitiated = "Return Initiated",
    PickupScheduled = "Pickup Scheduled",
    Returned = "Returned",
    ExchangeInitiated = "Exchange Initiated",
    ExchangePacked = "Exchange Packed",
    ExchangeDispatched = "Exchange Dispatched",
    Exchanged = "Exchanged",
}

export enum OrderStatusNext {
    Failed = "",
    Pending = "Ordered",
    Ordered = "Packed",
    Packed = "Dispatched",
    Cancelled = "",
    Dispatched = "Delivered",
    Delivered = "",
    ExchangeInitiated = "Exchange Initiated",
    ExchangePacked = "Exchange Packed",
    ExchangeDispatched = "Exchange Dispatched",
    Exchanged = "Exchanged",
    ReturnInitiated = "Pickup Scheduled",
    PickupScheduled = "Returned",
    Returned = "",
}

export interface ProductInput {
    id?: number | null;
    structureId?: number | null;
    quantity?: number;
    singleBlockInfo?: SingleBlockInfo | null;
}

export interface OrderItemData {
    type: "product" | "structure";
    product?: ProductAttributes;
    structure?: StructureAttributes;
    quantity: number;
    singleBlockInfo?: SingleBlockInfo | null;
}

export interface OrderSummary {
    totalMRP: number;
    storeDiscount: number;
    subtotal: number;
    couponDiscount: number;
    deliveryCharge: number;
    total: number;
    coinsUsed: number;
    paymentAmount: number;
    // products: ProductAttributes[];
    items: OrderItemData[];
}

export interface BaseOrder {
    products?: ProductInput[];
    originalSubTotal?: number;
    originalCouponDiscount?: number;
    originalTotal?: number;
    originalCoinsUsed?: number;
    originalPaymentAmount?: number;
    currentSubTotal?: number;
    currentCouponDiscount?: number;
    currentTotal?: number;
    currentCoinsUsed?: number;
    currentPaymentAmount?: number;
    couponId?: number;
    isCoinUsed?: boolean;
    deliveryCharge: number;
    customerName?: string;
    customerEmail?: string;
    addressID?: number;
    recipientName?: string;
    recipientMobileNumber?: string;
    recipientAddressType?: string;
    recipientAddress?: string;
    recipientCity?: string;
    recipientState?: string;
    recipientPincode?: number;
    recipientHouseNumber?: string;
    customerMobile: string;
    orderStatus?: OrderStatus;
    paymentMethod?: PaymentMethod;
    paymentGateway?: string;
    paymentStatus?: string;
    paymentStatusDetails?: PhonePeResponse | PaymentDetailData[];
    paymentReference?: string;
    pickupDate?: Date;
    pickupTime?: string;
    awbNumber?: string;
    courierName?: string;
    createdAt?: Date;
    updatedAt?: Date;
    returnReason?: string;
    refundOption?: string;
    accountHolderName?: string;
    accountNumber?: string;
    ifscCode?: string;
    upiId?: string;
    isFromCart: boolean;
    orderAddress?: OrderAddress;
}

export interface OrderAttributes extends BaseOrder {
    id: number;
    orderAddress?: OrderAddress;
    orderItems?: OrderItemAttributes[];
    Refunds?: BaseRefund[];
    refundAmount?: number;
    refundStatus?: string;
    refundReference?: string;
    refundDate?: Date;
    reviews?: BaseReview[];
    orderStatusHistory?: AdminStatusHistoryModel[];
}

export type NullableOrder = OrderAttributes | null;

export interface OrderConfirmation {
    orderId: number;
    recipientName: string;
    recipientMobileNumber: string;
    recipientAddressType: string;
    recipientAddress: string;
    recipientCity: string;
    recipientState: string;
    recipientPincode: number;
    recipientHouseNumber: string;
    product?: OrderItemAttributes[];
    customerName?: string;
    customerEmail?: string;
    customerMobile: string;
    placedOn?: string;
    message: string;
    message1?: string;
    message2?: string;
    message3?: string;
    message4?: string;
    message5?: string;
    message6?: string;
    imageUrl: string;
    orderLink: string;
    subTotal?: number;
    couponDiscount: number;
    total?: number;
    coinsUsed?: number;
    amountLabel: string;
    paymentAmount?: number;
    deliveryCharge: number;
    title?: string;
    awbNumber?: string;
    courierName?: string;
    trackingUrl?: string;
}
export interface HelpOrderBody {
    orderId: number;
    placedOn: string;
    message: string;
    imageUrl: string;
    orderLink: string;
}

export interface CalculatedRefundDetails {
    refundCash: number | null;
    refundCoins: number | null;
    hasMultipleCoins: boolean;
    totalRefund: number;
    contactUrl: string;
}

export interface OrderStatusConfirmation {
    projectLogoUrl: string;
    projectName: string;
    customerName: string;
    emailTitle: string;
    itemsTitle: string;
    message: string;
    message2?: string;
    orderItems: OrderItemAttributes[];
    orderPlacedOn: string;
    orderId: number;
    orderLink: string;
    refundDetails?: CalculatedRefundDetails;
    orderIdMessage: string;
    orderOn: string;
    viewOrder: string;
    refundDetail: string;
    cashRefund: string;
    refundStatus: string;
    processing: string;
    expected: string;
    rewardCredit: string;
    coin: string;
    totalRefundLabel: string;
    refundProcess: string;
    query: string;
    thank: string;
}

export interface pickupScheduledModel extends OrderConfirmation {
    pickupDate: string;
    pickupTime: string;
}

export enum OrdersByMobileNumber {
    Failed = "No orders found for the given mobile number",
    OrderFailed = "Error fetching orders by mobile number",
}

export interface OrderPageResponse {
    rows: OrderAttributes[];
    count: number;
    products?: ProductAttributes[];
}

export enum Action {
    Return = "Return",
    Cancel = "Cancel",
}

export interface Message {
    message: string;
}

export enum ErrorMessageSendEmail {
    FailedRequest = "Failed to send help request email",
    Failed = "Failed to send an email.",
    success = "Email sent successfully",
    OrderNotFound = "Order not found",
    MailSent = "HelpRequest sent successfully",
}

export enum OrderErrorMessage {
    OrderNotFound = "Order not found",
    OrderNotCreated = "Order not created",
}

export const orderListColumns: TableColumn[] = [
    { key: "action", value: "Action", type: "action" },
    { key: "id", value: "Order ID", type: "number" },
    { key: "orderStatus", value: "Status", type: "text" },
    { key: "currentTotal", value: "Total Price", type: "price" },
    { key: "currentCoinsUsed", value: "Coins Used", type: "number" },
    { key: "currentPaymentAmount", value: "Payment Amount", type: "price" },
    { key: "createdAt", value: "Created At", type: "datetime" },
    { key: "updatedAt", value: "Updated At", type: "datetime" },
];

export interface OperationsModel {
    label: string;
    value: string;
    placeholder: string;
    controlName: string;
    type: string;
    options?: { value: string; label: string }[];
}

export interface status {
    title: string;
    display: boolean;
    highlight: boolean;
    belongsTo: string;
    date: string;
}

export { RefundStatus };
export interface OrderStatusItem {
    status: string;
    label: string;
    icon: string;
}

export enum OrderMessage {
    CreateFail = "Failed to create order",
    UpdateSuccess = "Updated successfully",
    UpdateFail = "Updation failed",
    FailFetchOrder = "Failed to fetch order",
    FailFetchOrders = "Failed to fetch orders",
    FailGetOrderDetail = "Fail to get the Order Details",
    FetchStatusFail = "Fail to fetch all the status",
    FailedRequest = "Failed to send help request email",
    ItemUnavailable = "Some items are currently unavailable. Please review in cart.",
    OrderAlreadyCancelled = "This order is already cancelled",
    OrderAlreadyDispatched = "This order is already dispatched",
    OrderAlreadyDelivered = "This order is already delivered",
    UnknownError = "An unknown error occurred",
    CancelSuccess = "Order cancelled successfully.",
    CancelFailed = "Failed to cancel the order. Please try again later",
    ReturnInitiationSuccess = "Return process initiated successfully.",
    ReturnInitiationFailed = "Failed to initiate the return process. Please try again later.",
    ExchangeInitiationSuccess = "Exchange process initiated successfully.",
    OrderNotFound = "Order not found.",
}

export interface DialogSaveDataModel {
    reason: string;
    utrNumber: string;
    refundOption?: string;
    bankDetails?: {
        accountHolderName: string;
        accountNumber: string;
        ifscCode: string;
    };
    upi?: {
        upiId: string;
    };
}

export interface OrderAddress {
    billingAddress: AddressDetailsAttributes;
    shippingAddress: AddressDetailsAttributes;
}

export interface PickupScheduledData {
    imageUrl: string;
    customerName: string;
    message: string;
    message2: string;
    pickupDate: string;
    pickupTime: string;
    recipientMobileNumber: string;
    recipientAddressType: string;
    recipientAddress: string;
    recipientCity: string;
    recipientState: string;
    recipientPincode: number;
    recipientName: string;
    recipientHouseNumber: string;
    orderLink: string;
    orderId: number;
    orderItems: OrderItemAttributes[];
    title: string;
    pickupAddress: string;
    houseNo: string;
    pickupDateMessage: string;
    pickupTimeMessage: string;
    thank: string;
    company: string;
}

export interface DispatchData {
    imageUrl: string;
    message: string;
    message1: string;
    message2: string;
    message3: string;
    wishText: string;
    trackOrderText: string;
    footerText: string;
    awbNumberLabel: string;
    deliveryAddress: string;
    courierService: string;
    awbNumber: string;
    courierName: string;
    recipientMobileNumber: string;
    recipientAddressType: string;
    recipientAddress: string;
    recipientCity: string;
    recipientState: string;
    recipientPincode: number;
    recipientName: string;
    recipientHouseNumber: string;
    orderLink: string;
    orderId: number;
    trackingUrl: string;
    orderItem: OrderItemAttributes[];
}

export interface ReturnConfirmData {
    projectName: string;
    projectLogoUrl: string;
    emailTitle: string;
    customerName: string;
    orderId: number;
    isCod: boolean;
    refundCash: number;
    refundCoins: number;
    hasMultipleCoins: boolean;
    totalRefund: number;
    contactUrl: string;
}

export interface BaseOrderAddresses {
    id?: number;
    orderID: number;
    billingAddressID: number;
    shippingAddressID: number;
}

export interface BaseOrderStatusHistory {
    id?: number;
    orderId: number;
    status: string;
    adminUser?: number;
}

export enum RefundOption {
    BankDetails = "bankDetails",
    Upi = "upi",
}

export interface ReturnReasonPayload {
    id?: number;
    returnReason: string;
}

export interface ExchangeReasonPayload {
    id?: number;
    exchangeReason: string;
}

export interface CancelReasonPayload {
    id?: number;
    cancelReason: string;
}

export const NonReviewableOrderStatuses = [
    OrderStatus.Cancelled,
    OrderStatus.Pending,
    OrderStatus.Ordered,
    OrderStatus.Packed,
    OrderStatus.Dispatched,
];

export enum OrderItemFilterStatus {
    Cancellable = "Cancellable",
    Returnable = "Returnable",
    Exchangeable = "Exchangeable",
}

export const OrderItemStatusMapping = {
    cancellable: [OrderStatus.Ordered, OrderStatus.Packed],
    returnable: [OrderStatus.Delivered, OrderStatus.Exchanged],
    exchangeable: [OrderStatus.Delivered],
};
